import React, { useEffect, useRef, useState } from "react";
import UpArrowIcon from "../../icon-library/UpArrowIcon";
import DownArrowIcon from "../../icon-library/DownArrowIcon";

import PropTypes from "prop-types";

const Expando = ({
  id = Date.now() + "",
  title,
  children,
  classList = "",
  headingClassList = "",
  buttonClassList = "",
  expandoButton = DownArrowIcon(),
  collapseButton = UpArrowIcon(),
  buttonCallback = () => {},
  initialHeight = "0",
  parentScrollRef = false,
  initialOpen = false
}) => {
  const [maxHeight, setMaxHeight] = useState(initialHeight);
  const [ExpandoStyles, setExpandoStyles] = useState({
    maxHeight: initialOpen ? "auto" : `${initialHeight}px`
  });
  const [isOpen, setIsOpen] = useState(initialOpen);
  const ExpandoContainer = useRef();

  const calculatedHeight = () => {
    //calculate height of all the children!
    let children = [...ExpandoContainer.current.children];
    let height = 0;
    children.forEach((child) => (height += child.offsetHeight));
    return height;
  };

  useEffect(() => {
    if (initialOpen && ExpandoContainer.current) {
      setMaxHeight(calculatedHeight());
    }
  }, [initialOpen]);

  useEffect(() => {
    setExpandoStyles({
      maxHeight: isOpen ? `${maxHeight}px` : `${initialHeight}px`
    });
  }, [isOpen, maxHeight, initialHeight]);

  const toggleExpando = (e) => {
    e.preventDefault();

    setIsOpen(!isOpen);
    setMaxHeight(isOpen ? initialHeight : calculatedHeight());

    if (isOpen) {
      parentScrollRef
        ? parentScrollRef.current.scrollIntoView()
        : ExpandoContainer.current.scrollIntoView();
    }

    buttonCallback();
  };

  const handleKeyPress = (e) => {
    if (e.key === " " || e.key === "Enter") {
      toggleExpando();
    }
  };

  // replace spaces with underscores and make lowercase
  const cleanString = (str) => {
    if (str && typeof str === "string") {
      return str.replace(/\s/g, "_").toLowerCase();
    }
  };

  return (
    <div
      className={`expando ${classList} ${isOpen ? "expando--is-open" : ""}`}
      data-testid="expando-wrapper"
    >
      <button
        type="button"
        className={`expando__button btn btn-text ${buttonClassList}`}
        onClick={toggleExpando}
        onKeyPress={handleKeyPress}
        aria-expanded={isOpen}
        tabIndex="0"
        data-link-type="toggle"
        data-link-target="internal_link"
        data-link-info={cleanString(title)}
      >
        <div className="expando__heading">
          <span className="expando__title">{title}</span>{" "}
          <span className="expando__icon">{!isOpen ? expandoButton : collapseButton}</span>
        </div>
      </button>

      <div className="expando__content" ref={ExpandoContainer} style={ExpandoStyles}>
        {children}
      </div>
    </div>
  );
};

Expando.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonCallback: PropTypes.func,
  expandoButton: PropTypes.object,
  collapseButton: PropTypes.object,
  children: PropTypes.node.isRequired,
  headingClassList: PropTypes.string,
  buttonClassList: PropTypes.string,
  classList: PropTypes.string,
  id: PropTypes.string,
  initialHeight: PropTypes.number,
  parentScrollRef: PropTypes.object,
  initialOpen: PropTypes.bool
};

export default Expando;
